"use client";
import dynamic from "next/dynamic";
const TrackSessionId = dynamic(
  () =>
    import(
      "@packages/lib/utlils/tracksessionid" 
    ),
  { ssr: false }
);
const GoogleOneTap = dynamic(
  () =>
    import(
      "@packages/lib/utlils/GoogleOneTap" 
    ),
  { ssr: false }
);
const SetCookiewuIdToken = dynamic(
  () =>
    import(
      "@packages/lib/utlils/setcookie" 
    ),
  { ssr: false }
);
const GTMScript = dynamic(
  () =>
    import("@packages/lib/utlils/loadgtm_webworker/loadGtm" ),
  {
    ssr: false,
  }
);
const OneTrustCookieScript = dynamic(
  () =>
    import("@packages/lib/oneTrust/OneTrustCookieScript" ),
  {
    ssr: false,
  }
);

export default function ClientWrapper() {
  return (
    <>
    <OneTrustCookieScript/>
      <TrackSessionId />
      <GoogleOneTap />
      <SetCookiewuIdToken />
      <GTMScript Gtm_Id={process.env.NEXT_PUBLIC_WU_GTM_ACCOUNT}/>
    </>
  );
}
